<template>
  <div>
    <div class="color-swap p-4 border border-black rounded" :style='{"background-color":value}' @click='toggleModal'>
    </div>
    <pbc-modal title='Color' v-if='isShowingModal' @done='onOk' @close='onCancel' >
      <chrome v-model='color' @input='update' @ok='onOk' @cancel='onCancel' class="mx-8 py-8" />
    </pbc-modal>
  </div>

</template>
<script>
import { Chrome } from 'vue-color'
export default {
  components:{
    Chrome
  },
  data() {
    return {
      isShowingModal:false,
      originalColor:this.value,
      color:this.value
    }
  },
  props:{
    value:{
      type:String,
      required:true
    }
  },
  mounted() {
    if (typeof(this.value) ==='undefined' || this.value === '') {
      this.value = '#ffffff';
    }
  },
  methods:{
    update(col) {
      this.$emit('input', this.color.hex);
    },
    toggleModal() {
      this.isShowingModal = !this.isShowingModal;
      this.$emit('input', this.value);
    },
    onOk() {
      this.isShowingModal = false;
    },
    onCancel() {
      this.isShowingModal = false;
      this.$emit('input', this.originalColor);
    }
  }
}
</script>
<style>
.color-swab {
  height:40px;
  width:100%;
}
</style>
